export default __webpack_public_path__ + "82a03927cd8d1150ed57261dbb28fe0e.png";